import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { VendorsResolverService } from '../_shared/_resolvers/vendors-resolver.service';

const routes: Routes = [
  {
    path: '',
    loadComponent: async () => import('./hot-tub-care.component').then(m => m.HotTubCareComponent),
    resolve: {
      vendors: VendorsResolverService
    },
    data: { title: 'Hot Tub Supplies' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HotTubCareRoutingModule { }
